/**
 * @description: https://bytedance.feishu.cn/wiki/JVfAwkI0hiq1VGknawYcYdOdnxd
 * @author wuyan.geass
 */
import { i18n } from '@features/libs';
// @ts-expect-error
import { useTranslation as useJupiterTranslation } from '@jupiter/plugin-runtime/i18n';

type I18nParams = (string | number)[] | { [key: string]: string | number };
export interface ILocaleMap {
  i18nKey: string;
  defaultText: string;
  // for plural https://bytedance.feishu.cn/docs/doccnXcxYvOdMaOA2crZN286ahg
  count?: number;
}

const useTranslation = (ns?: string, config?: any) => {
  const [t] = useJupiterTranslation(ns, config);

  function hocT(
    key: string,
    options?: string | Record<string, any>,
    param?: I18nParams,
  ): string;
  function hocT(value: ILocaleMap, param?: I18nParams): string;
  function hocT<T extends string | ILocaleMap>(
    key: T,
    options?: T extends string ? string | Record<string, any> : I18nParams,
    param?: T extends string ? I18nParams : undefined,
  ): string {
    const opts =
      typeof options === 'string'
        ? {
            defaultValue: options,
            ...param,
          }
        : {
            ...(options as I18nParams),
            interpolation: undefined,
            ...param,
          };
    if (typeof key === 'string') {
      // show i18nKey
      if ((window as any).AghanimGlobalShowI18nKey) {
        return key;
      }
      return i18n.i18nFormat(t(key, opts), param);
    }
    const { i18nKey, defaultText } = key ?? {};
    // show i18nKey
    if ((window as any).AghanimGlobalShowI18nKey) {
      return i18nKey;
    }
    return i18n.i18nFormat(
      t(i18nKey, {
        ...opts,
        defaultValue: defaultText,
      }),
      options as I18nParams,
    );
  }
  return [hocT, i18n] as const;
};

export default useTranslation;
